// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"9902dfba","148":"6538a29a","647":"785a66f2","728":"20b16257","787":"08848d99"}[chunkId] + ".chunk.js";
};